__turbopack_context__.v({
  "ProjectImageCover": "index-module__w6vJpa__ProjectImageCover",
  "activeFilter": "index-module__w6vJpa__activeFilter",
  "containerSectionWarrper": "index-module__w6vJpa__containerSectionWarrper",
  "displayImage": "index-module__w6vJpa__displayImage",
  "filters": "index-module__w6vJpa__filters",
  "imageContainer": "index-module__w6vJpa__imageContainer",
  "listFilters": "index-module__w6vJpa__listFilters",
  "projectItem": "index-module__w6vJpa__projectItem",
  "projectListContainer": "index-module__w6vJpa__projectListContainer",
  "projectsList": "index-module__w6vJpa__projectsList",
  "selectedProjects": "index-module__w6vJpa__selectedProjects",
  "titleFill": "index-module__w6vJpa__titleFill",
  "titleOutline": "index-module__w6vJpa__titleOutline",
  "titles": "index-module__w6vJpa__titles",
  "visibleProject": "index-module__w6vJpa__visibleProject",
});
